// This is required for the codemirror merge function.  It has to be declared as globals.
import DiffMatchPatch from 'diff-match-patch';
window.diff_match_patch = DiffMatchPatch;
window.DIFF_INSERT = DiffMatchPatch.DIFF_INSERT;
window.DIFF_DELETE = DiffMatchPatch.DIFF_DELETE;
window.DIFF_EQUAL = DiffMatchPatch.DIFF_EQUAL;
